import { useAccounts } from 'src/hooks/use-accounts';

export function useProductFruitsEnabled(): boolean {
  const accounts = useAccounts();
  if (!accounts.current) return false; // never enable for guests

  if (PRISMA_CONFIG.stage === 'prod') return true;

  // on non-PROD stages, only enable for test accounts
  return !!PRISMA_CONFIG.productFruitsTestAccounts?.includes(
    accounts.current.cognitoUserName
  );
}
